"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = {
  name: 'TableListClients',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    actionDelete: {
      type: Function,
      default: function _default() {}
    }
  },
  methods: {
    action: function action(item) {
      this.actionDelete(item);
    }
  }
};
exports.default = _default2;